<template>
  <v-row justify="center">
    <v-col cols="8" class="px-0 pb-0">
      <v-toolbar color="transparent" flat height="48">
        <v-toolbar-title class="text--secondary body-1 font-weight-medium">Tu guía de inicio rápido</v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="8" v-if="loaderRetrieve">
      <v-skeleton-loader class="py-3" transition="fade-transition" type="card-heading" />
      <v-skeleton-loader class="py-3" transition="fade-transition" type="card-heading" />
      <v-skeleton-loader class="py-3" transition="fade-transition" type="card-heading" />
    </v-col>
    <v-col cols="8" v-else>
      <v-expansion-panels v-model="epMain" accordion flat>
        <!-- know piriod -->
        <v-expansion-panel class="my-3 rounded elevation-4">
          <v-expansion-panel-header class="py-6" @click="trackEvent('Quickstart Step Clicked', { element: 'Expansion Panel', step: 'Meet Piriod' })">
            <v-sheet>
              <v-row align="center" no-gutters>
                <v-col cols="6">
                  <v-badge color="primary" icon="mdi-check" bottom bordered overlap :value="onboardingCompleteSteps.length === onboardingSteps.length">
                    <v-icon color="primary">mdi-newspaper</v-icon>
                  </v-badge>
                  <span class="ml-5 body-1 text--secondary font-weight-medium">Conoce Piriod</span>
                </v-col>
                <v-col cols="4">
                  <v-progress-linear :value="onboardingProgress" color="primary" rounded />
                </v-col>
                <v-col cols="2">
                  <span class="ml-3 body-2 font-weight-medium">{{onboardingCompleteSteps.length}} de {{onboardingSteps.length}}</span>
                </v-col>
              </v-row>
            </v-sheet>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4 background rounded-b">
            <v-expansion-panels v-model="epMainInside" accordion flat>
              <!-- create a plan -->
              <v-expansion-panel class="my-2 rounded elevation-2">
                <v-expansion-panel-header>
                  <v-sheet>
                    <v-avatar color="primary" size="24" v-if="editableOnboarding.plan"><v-icon dark>mdi-check</v-icon></v-avatar>
                    <v-avatar color="secondary" size="24" v-else><span class="white--text body-2">1</span></v-avatar>
                    <span class="ml-4 body-1 text--secondary font-weight-medium">Crea un plan</span>
                  </v-sheet>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item two-line>
                          <v-list-item-content class="py-1">
                            <v-list-item-title class="px-1 body-2 text--secondary font-weight-medium">Nombre</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field v-model.trim="$v.plan.name.$model" :error="$v.plan.name.$error" :disabled="formsList.length > 0" background-color="white" outlined required single-line dense maxlength="35" hint="Nombre es requerido." persistent-hint :hide-details="!$v.plan.name.$error" placeholder="Mensual" />
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                          <v-list-item-content class="py-1">
                            <v-list-item-title class="px-1 body-2 text--secondary font-weight-medium">Moneda</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-autocomplete v-model.trim="$v.plan.currency.$model" :items="currencies" item-value="id" item-text="name" :disabled="formsList.length > 0" label="Elige una moneda" :menu-props="{ overflowY: true, nudgeBottom: '10', transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                                <template v-slot:item="data">
                                  <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                                </template>
                              </v-autocomplete>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                          <v-list-item-content class="py-1">
                            <v-list-item-title class="px-1 body-2 text--secondary font-weight-medium">Precio</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-col cols="8" class="pa-0">
                                <v-text-field v-model.number="$v.plan.amount.$model" :error="$v.plan.amount.$error" :disabled="formsList.length > 0" :suffix="plan.currency" hint="Escribe un precio" persistent-hint :hide-details="!$v.plan.amount.$error" background-color="white" outlined required single-line dense placeholder="0.00" />
                              </v-col>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                          <v-list-item-content class="py-1">
                            <v-list-item-title class="px-1 body-2 text--secondary font-weight-medium">Frecuencia de facturación</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-col cols="8" class="pa-0">
                                <v-select v-model="plan.frequency" :items="frequencies" item-value="id" item-text="name" :disabled="formsList.length > 0" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                              </v-col>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-action class="px-1">
                              <v-btn @click="completeStepOne" :loading="$store.state.subscriptions.createLoader" color="primary">Continuar</v-btn>
                            </v-list-item-action>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="6">
                      <span class="d-block mb-4">En Piriod tus productos y servicios los puedes gestionar de forma eficaz creando un plan para cada conjunto de características de producto o servicio.</span>
                      <span class="d-block mb-4">Tus clientes se inscribirán a estos planes mediante suscripciones.</span>
                      <span class="d-block mb-4">El precio de un plan se establece de acuerdo con el tipo de precio elegido. Más adelante podrás establecer precios como:</span>
                      <v-row no-gutters>
                        <v-col>
                          <v-list>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="mr-1 my-2"><v-icon color="primary" small>mdi-chart-timeline</v-icon></v-list-item-icon>
                              <v-list-item-title>Tarifa plana</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="mr-1 my-2"><v-icon color="primary" small>mdi-chart-sankey</v-icon></v-list-item-icon>
                              <v-list-item-title>Por cantidad</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="mr-1 my-2"><v-icon color="primary" small>mdi-chart-gantt</v-icon></v-list-item-icon>
                              <v-list-item-title>Escalonado</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col>
                          <v-list>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="mr-1 my-2"><v-icon color="primary" small>mdi-chart-line</v-icon></v-list-item-icon>
                              <v-list-item-title>Por volumen</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="mr-1 my-2"><v-icon color="primary" small>mdi-chart-bar-stacked</v-icon></v-list-item-icon>
                              <v-list-item-title>Por tramo</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                              <v-list-item-icon class="mr-1 my-2"><v-icon color="primary" small>mdi-chart-multiple</v-icon></v-list-item-icon>
                              <v-list-item-title>Por uso</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- end create a plan -->

              <!-- branding -->
              <v-expansion-panel class="my-2 rounded elevation-2">
                <v-expansion-panel-header>
                  <v-sheet>
                    <v-avatar color="primary" size="24" v-if="editableOnboarding.branding"><v-icon dark>mdi-check</v-icon></v-avatar>
                    <v-avatar color="secondary" size="24" v-else><span class="white--text body-2">2</span></v-avatar>
                    <span class="ml-4 body-1 text--secondary font-weight-medium">Personaliza tu marca</span>
                  </v-sheet>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="5">
                      <v-list>
                        <v-list-item two-line>
                          <v-list-item-content class="py-2">
                            <v-list-item-title class="px-1 body-2 text--secondary font-weight-medium">Logo</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-sheet>
                                <input ref="editableBranding.logo" type="file" accept="image/png" style="display:none" @change="getLogoPreview">
                                <v-btn v-if="!logoPreview && !editableBranding.logo" @click="$refs['editableBranding.logo'].click()" outlined color="secondary"><v-icon>mdi-plus</v-icon></v-btn>
                                <v-hover v-if="logoPreview || editableBranding.logo" v-slot:default="{hover}">
                                  <v-img :loading="logoPreview" :aspect-ratio="4" contain class="rounded" :src="logoPreview ? logoPreview : editableBranding.logo" @click="$refs['editableBranding.logo'].click()" max-width="200" min-height="90" style="border:1px solid #D8E0EA;">
                                    <v-expand-transition>
                                      <div v-if="hover" class="d-flex transition-fast-in-fast-out background v-card--reveal primary--text font-weight-medium" style="cursor:pointer; height:100%;">Seleccionar</div>
                                    </v-expand-transition>
                                    <template v-slot:placeholder>
                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular size="30" indeterminate color="blue lighten-4" />
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-hover>
                              </v-sheet>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                          <v-list-item-content class="py-2">
                            <v-list-item-title class="px-1 body-2 text--secondary font-weight-medium">Color principal</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-sheet width="140">
                                <v-text-field v-model="$v.editableBranding.color_background.$model" reverse background-color="white" outlined required single-line dense hide-details>
                                  <template v-slot:append>
                                    <v-menu v-model="menuColor" bottom :close-on-content-click="false">
                                      <template v-slot:activator="{ on }">
                                        <div :style="swatchStyle" v-on="on" />
                                      </template>
                                      <v-card>
                                        <v-card-text class="pa-0">
                                          <v-color-picker v-model="$v.editableBranding.color_background.$model" flat width="250" />
                                        </v-card-text>
                                      </v-card>
                                    </v-menu>
                                  </template>
                                </v-text-field>
                              </v-sheet>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-action class="px-1">
                              <v-btn @click="completeStepTwo" :loading="$store.state.accounts.createLoader" color="primary">Continuar</v-btn>
                            </v-list-item-action>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="7">
                      <v-card outlined rounded>
                        <v-app-bar class="mb-10" :color="editableBranding.color_background">
                          <v-spacer />
                          <v-sheet class="overflow-hidden mt-8" v-if="logoPreview || editableBranding.logo" width="80" rounded outlined>
                            <v-responsive class="align-center" :aspect-ratio="1/1">
                              <v-sheet class="px-1" color="white" width="80">
                                <v-img :src="logoPreview ? logoPreview : editableBranding.logo" width="100%" />
                              </v-sheet>
                            </v-responsive>
                          </v-sheet>
                          <v-spacer />
                        </v-app-bar>
                        <v-stepper v-model="brandingStepper" alt-labels>
                          <v-stepper-header>
                            <v-stepper-step class="py-1" step="1" :color="editableBranding.color_background" complete><span class="body-2 text--secondary">Plan</span></v-stepper-step>
                            <v-divider class="mt-4" />
                            <v-stepper-step class="py-1" step="2" :color="editableBranding.color_background"><span class="body-2">Facturación</span></v-stepper-step>
                            <v-divider class="mt-4" />
                            <v-stepper-step class="py-1" step="3" :color="editableBranding.color_background"><span class="body-2">Pago</span></v-stepper-step>
                          </v-stepper-header>
                          <v-stepper-items>
                            <v-stepper-content class="pa-0" step="2">
                              <v-skeleton-loader :boilerplate="true" type="article"></v-skeleton-loader>
                            </v-stepper-content>
                          </v-stepper-items>
                        </v-stepper>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- end branding -->

              <!-- preview -->
              <v-expansion-panel class="my-2 rounded elevation-2">
                <v-expansion-panel-header>
                  <v-sheet>
                    <v-avatar color="primary" size="24" v-if="editableOnboarding.signup_form"><v-icon dark>mdi-check</v-icon></v-avatar>
                    <v-avatar color="secondary" size="24" v-else><span class="white--text body-2">3</span></v-avatar>
                    <span class="ml-4 body-1 text--secondary font-weight-medium">Previsualiza la experiencia de registro</span>
                  </v-sheet>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pl-5">
                  <v-row align="center">
                    <v-col cols="6">
                      <span class="d-block mb-4">Signup Forms de Piriod hace que sea fácil para tu negocio comenzar a suscribir clientes de forma auto asistida.</span>
                      <span class="d-block mb-8">En este paso, te pondrás en el lugar de tu cliente y verás cómo este se puede suscribir a tu plan.</span>
                      <v-btn color="primary" @click="completeStepThreeAndFour" :disabled="!formsDetail.publishable_key">Previsualizar<v-icon small right>mdi-open-in-new</v-icon></v-btn>
                      <span class="d-block mt-4 body-2 primary--text text-decoration-underline" v-if="!formsDetail.publishable_key">Completa el paso 1 para continuar</span>
                    </v-col>
                    <v-col cols="6">
                      <v-img contain :src="require('@/assets/appAsset-quickstart--Preview.svg')" max-height="380" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- end preview -->

              <!-- setup -->
              <v-expansion-panel class="my-2 rounded elevation-2" :disabled="!formsDetail.publishable_key">
                <v-expansion-panel-header>
                  <v-sheet>
                    <v-avatar color="primary" size="24" v-if="editableOnboarding.signup_form"><v-icon dark>mdi-check</v-icon></v-avatar>
                    <v-avatar color="secondary" size="24" v-else><span class="white--text body-2">4</span></v-avatar>
                    <span class="ml-4 body-1 text--secondary font-weight-medium">Instala el widget en tu aplicación o sitio web</span>
                  </v-sheet>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-5">
                  <v-row>
                    <v-col md="12">
                      <span class="d-block mt-2 body-2">Copia y pega este fragmento de código antes de la etiqueta <code class="background text--secondary">&lt;/body&gt;</code> en todas las páginas en las que deseas que Signup Forms aparezca para tu usuario.</span>
                    </v-col>
                    <v-col md="12">
                      <v-sheet outlined rounded>
                        <pre v-highlightjs="snippet"><code class="rounded html background font-weight-regular"></code></pre>
                      </v-sheet>
                    </v-col>
                    <v-col cols="8">
                      <span class="body-2">Usa nuestra <a class="btnLink font-weight-medium" :href="`${$DOCS_BASE}/docs/apps-signup_forms`" target="_blank">Guía de instalación</a> para configurar tu Signup Forms.</span>
                    </v-col>
                    <v-col cols="4" class="text-right">
                      <v-btn class="mt-n2" @click="toClipboard(snippet), trackEvent('Quickstart Element Clicked', { action_label: 'Copy snippet', element: 'Button' })" color="primary">Copiar snippet</v-btn>
                    </v-col>
                    <v-col cols="12">
                      <span class="body-2 text--secondary font-weight-medium">Otras formas de registrar suscriptores en Piriod</span>
                    </v-col>
                    <v-col cols="3">
                      <v-card class="py-0 card-apps background" :to="{ name: 'FormDetail', params: { id: formsDetail.id } }" target="_blank" :ripple="false">
                        <v-card-text class="px-2 text-center">
                          <v-responsive class="align-center" :aspect-ratio="6/5">
                            <v-icon color="primary" large>mdi-format-list-text</v-icon>
                            <span class="d-block mt-3 text--secondary font-weight-medium">Signup Form alojado</span>
                          </v-responsive>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                      <v-card class="py-0 card-apps background" :href="`${$DOCS_BASE}/api/subscriptions/subscriptions`" target="_blank" :ripple="false">
                        <v-card-text class="px-2 text-center">
                          <v-responsive class="align-center" :aspect-ratio="6/5">
                            <v-icon color="primary" large>mdi-code-json</v-icon>
                            <span class="d-block mt-3 text--secondary font-weight-medium">Integrando la API</span>
                          </v-responsive>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                      <v-card class="py-0 card-apps background" :to="{ name: 'SubscriptionCreate' }" target="_blank" :ripple="false">
                        <v-card-text class="px-2 text-center">
                          <v-responsive class="align-center" :aspect-ratio="6/5">
                            <v-icon color="primary" large>mdi-view-quilt</v-icon>
                            <span class="d-block mt-3 text--secondary font-weight-medium">Usando el panel</span>
                          </v-responsive>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- end setup -->
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end know piriod -->

        <!-- connect payment provider -->
        <v-expansion-panel class="my-3 rounded elevation-4">
          <v-expansion-panel-header class="py-6" @click="trackEvent('Quickstart Step Clicked', { element: 'Expansion Panel', step: 'Connect a payments provider' })">
            <v-sheet>
              <v-badge color="primary" icon="mdi-check" bottom bordered overlap :value="providersList.length > 0">
                <v-icon color="primary">mdi-credit-card</v-icon>
              </v-badge>
              <span class="ml-5 body-1 text--secondary font-weight-medium">Conecta un proveedor de pagos</span>
            </v-sheet>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4 background rounded-b">
            <v-row align="center" justify="space-between">
              <v-col cols="12" v-if="providersList.length > 0">
                <v-alert class="mb-0 pr-3 body-2" dark dense prominent color="indigo" border="left" type="success">
                  <v-row align="center" no-gutters>
                    <v-col class="grow">
                      ¡Genial! Ya estás procesando pagos con Piriod. Siempre puedes ir a la configuración para conectar o desconectar un proveedor de pagos.
                    </v-col>
                    <v-col class="shrink">
                      <v-btn :to="{name: 'Integrations'}" color="indigo darken-3">Ir a la configuración</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
              <v-col cols="6">
                <span class="d-block mb-4">El equivalente digital de una máquina de pagos de punto de venta es un portal para aceptar pagos en línea, ya sea cargos a tarjetas de crédito o débito como también pagos mediante billeteras digitales o transferencias bancarias.</span>
                <span class="d-block mb-8">Piriod admite una gran cantidad de proveedores de pagos con los que puedes obtener una cuenta y comenzar a procesar pagos.</span>
                <v-btn color="primary" @click="trackEvent('Quickstart Step Completed', { action_label: 'Connect', element: 'Button', step: 'Connect a payments provider' })" :to="{ name: 'Integrations' }">Conectar</v-btn>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="4" v-for="d in gateways" :key="d.id">
                    <v-card flat>
                      <v-card-text class="px-2 text-center">
                        <v-responsive class="align-center" :aspect-ratio="6/5">
                          <img class="mt-2" :src="require(`@/assets/appAsset-brand--${d.id}.svg`)" height="22px" />
                        </v-responsive>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end connect payment provider -->

        <!-- local invoices -->
        <v-expansion-panel class="my-3 rounded elevation-4">
          <v-expansion-panel-header class="py-6" @click="trackEvent('Quickstart Step Clicked', { element: 'Expansion Panel', step: 'Activate local invoicing' })">
            <v-sheet>
              <v-badge color="primary" icon="mdi-check" bottom bordered overlap :value="billerconnectionsList.length > 0">
                <v-icon color="primary">mdi-file-document</v-icon>
              </v-badge>
              <span class="ml-5 body-1 text--secondary font-weight-medium">Activa la facturación local</span>
            </v-sheet>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4 background rounded-b">
            <v-row align="center" justify="space-between">
              <v-col cols="12" v-if="billerconnectionsList.length > 0">
                <v-alert class="mb-0 pr-2 body-2" dark dense prominent color="indigo" border="left" type="success">
                  <v-row align="center" no-gutters>
                    <v-col class="grow">
                      ¡Genial! Ya tienes conectada la facturación local.
                    </v-col>
                    <v-col class="shrink">
                      <v-btn @click="trackEvent('Quickstart Step Completed', { action_label: 'Go to activate', element: 'Button', step: 'Activate local invoicing' })" color="indigo darken-3" :to="{ name: 'Integrations' }">Ir a la configuración</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
              <v-col cols="6">
                <span class="d-block mb-4">Activa la conexión con la agencia fiscal de tu país para utilizar las facturas locales como documento de cobro en Piriod.</span>
                <span class="d-block mb-8">Puedes aprovechar esta conexión para tus facturas de suscripción, facturas únicas o facturas por lote.</span>
                <v-btn class="mr-3" color="primary" :to="{name: 'Integrations'}">Ir a activar</v-btn>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="4" v-for="d in taxAgencies" :key="d">
                    <v-card flat>
                      <v-card-text class="px-2 text-center">
                        <v-responsive class="align-center" :aspect-ratio="6/5">
                          <img class="mt-2" :src="require(`@/assets/appAsset-brand--${d}.svg`)" height="22px" />
                        </v-responsive>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end local invoices -->
      </v-expansion-panels>

      <!-- help -->
      <v-alert class="mt-3 mb-0 body-2 v-alert-custom" dark dense prominent color="indigo" border="left" icon="mdi-forum">
        <v-row align="center">
          <v-col class="grow">
            <span class="body-1 font-weight-medium">¿Necesitas ayuda para iniciar?</span>
          </v-col>
          <v-col class="shrink">
            <v-btn @click="intercomNewMessage('Hola, necesito ayuda para iniciar con Piriod'), trackEvent('Quickstart Element Clicked', { action_label: 'Request help', element: 'Button' })" color="indigo darken-3" :ripple="false">Solicitar ayuda</v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <!-- end help -->

    </v-col>
    <v-col cols="8">
      <v-row align="center">
        <v-col cols="12">
          <v-toolbar color="transparent" flat height="32">
            <v-toolbar-title class="text--secondary body-1 font-weight-medium">Aprende más</v-toolbar-title>
          </v-toolbar>
        </v-col>
        <v-col cols="6" class="py-0">
          <v-list class="transparent" flat>
            <v-hover v-slot:default="{hover}">
              <v-list-item @click="trackEvent('Quickstart Element Clicked', { action_label: 'Implementation guide', element: 'Link' })" :href="`${$DOCS_BASE}/docs/getting-started-implementation_guide`" target="_blank" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">
                    <span :class="{ 'indigo--text': hover }">Guía de implementación</span>
                    <v-icon class="mt-n1" :color="hover ? 'primary' : ''" size="18" right>mdi-open-in-new</v-icon>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--primary">Agiliza tu inicio en Piriod.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-hover>
            <v-hover v-slot:default="{hover}">
              <v-list-item @click="trackEvent('Quickstart Element Clicked', { action_label: 'Developers', element: 'Link' })" href="https://www.piriod.com/developers/" target="_blank" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">
                    <span :class="{ 'indigo--text': hover }">Developers</span>
                    <v-icon class="mt-n1" :color="hover ? 'primary' : ''" size="18" right>mdi-open-in-new</v-icon>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--primary">Ponte en marcha y comienza a desarrollar tu integración.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-hover>
          </v-list>
        </v-col>
        <v-col cols="6" class="py-0">
          <v-sheet class="mx-auto" outlined rounded max-width="345">
            <v-list-item @click="trackEvent('Quickstart Element Clicked', { action_label: 'YouTube Channel', element: 'Button' })" href="https://www.youtube.com/channel/UCyW-eqWzW6jiPDWb2N5e0qQ" target="_blank" link :ripple="false">
              <v-list-item-icon class="mr-4">
                <v-icon color="primary" size="36">mdi-youtube</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1 text--secondary font-weight-medium">YouTube Channel</v-list-item-title>
                <v-list-item-subtitle class="text--primary">Consulta recursos prácticos e historias.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { decimal, maxLength, minLength, required } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import gateways from '@/collections/gateways'

export default {
  name: 'quickstart',
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    brandingStepper: 2,
    editableBranding: {
      logo: '',
      color_background: '#000000'
    },
    editableOnboarding: {
      branding: false,
      plan: false,
      signup_form: false,
      signup_form_setup: false
    },
    epMain: 0,
    epMainInside: 0,
    form: {
      available_addons: [],
      available_countries: [],
      available_documents: [],
      available_plans: [{
        allow_quantity: false,
        description: '',
        name: '',
        plan: ''
      }],
      enable_hosted: true,
      name: 'Quickstart',
      require_source: true,
      test_mode: true
    },
    gateways: gateways,
    logoPreview: '',
    menuColor: false,
    plan: {
      amount: null,
      currency: 'USD',
      description: 'This is my first plan billed using Piriod',
      frequency: 'monthly',
      name: 'My First Plan',
      product: null
    },
    product: {
      name: 'Quickstart',
      unit_label: 'unit'
    },
    loaderRetrieve: false,
    taxAgencies: ['dian', 'sat', 'sii', 'sunat', 'aeta', 'sri']
  }),
  computed: {
    ...mapState({
      accountsDetail: state => state.accounts.accountsDetail,
      billerconnectionsList: state => state.billers.billerconnectionsList,
      formsDetail: state => state.apps.formsDetail,
      formsList: state => state.apps.formsList,
      onboarding: state => state.accounts.onboardingsList[0] || null,
      providersList: state => state.payments.providersList
    }),
    onboardingCompleteSteps () {
      return this.onboardingSteps.filter(s => this.editableOnboarding[s])
    },
    onboardingProgress () {
      return Math.round(this.onboardingCompleteSteps.length / this.onboardingSteps.length * 100)
    },
    onboardingSteps () {
      return Object.keys(this.editableOnboarding)
    },
    swatchStyle () {
      return {
        backgroundColor: this.$v.editableBranding.color_background.$model,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px'
      }
    },
    snippet () {
      const snippet = `
      <div id="piriod-widget"></div>

      <script>
        window.piriodSettings = {
          service: "signupForms",
          publishableKey: "${(this.formsDetail.publishable_key || '')}"
        };
        !function(){var e=document.getElementById("piriod-widget");if(!e)return console.log('Missing <div id="piriod-widget"></div>, create this to mounted.');var i=document.createElement("iframe");i.src="${process.env.VUE_APP_JS_BASE}/signup_forms/"+window.piriodSettings.publishableKey,i.id="piriod-widget",i.width="100%",i.height="740",i.style="border:none",e.appendChild(i)}();
      <\/script>
      `

      return snippet
    }
  },
  created () {
    this.loaderRetrieve = true

    Promise.all([
      this.$store.dispatch('accounts/LIST', {
        resource: 'onboardings',
        query: { page_size: 1 }
      }),
      this.$store.dispatch('apps/LIST', {
        resource: 'signup_forms/forms',
        query: { page_size: 1 }
      }),
      this.$store.dispatch('accounts/RETRIEVE', {
        resource: 'accounts',
        id: this.account.id
      }),
      this.$store.dispatch('payments/LIST', {
        resource: 'providers'
      }),
      this.$store.dispatch('billers/LIST', {
        resource: 'billerconnections',
        query: { page_size: 1 }
      })
    ])
    .then(() => {
      if (this.onboarding) {
        Object.keys(this.editableOnboarding).forEach(attr => {
          this.editableOnboarding[attr] = this.onboarding[attr]
        })
      }
    })
    .then(() => {
      if (this.formsList.length) {
        const form = cloneDeep(this.formsList[0])
        const ap = form.available_plans[0]

        Object.keys(this.plan).forEach(k => {
          if (typeof ap.plan[k] === 'object') {
            this.plan[k] = ap.plan[k].id
          } else {
            this.plan[k] = ap.plan[k] ? ap.plan[k] : ap[k]
          }
        })

        this.$store.dispatch('apps/RETRIEVE', {
          resource: 'signup_forms/forms',
          id: form.id
        })
      }
    })
    .then(() => {
      this.editableBranding.logo = this.accountsDetail.logo
      this.editableBranding.color_background = this.accountsDetail.color_background
    })
    .catch((error) => {
      if (error.response) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      }
    })
    .finally(() => {
      this.loaderRetrieve = false
    })
  },
  methods: {
    async completeStepOne () {
      if (this.formsList.length) {
        this.epMainInside = 1
      } else {
        // check plan attributes
        this.$v.plan.$touch()

        if (this.$v.plan.$invalid) {
          return false
        }

        // create a product
        const product = await this.createProduct()

        if (product) {
          this.plan.product = product.id
        } else {
          return false
        }

        // create a plan
        const plan = await this.createPlan()

        if (plan) {
          const currency = this.currencies.find(c => c.id === plan.currency.id)

          if (currency.conversion) {
            this.form.available_documents = [{ document: 'US1', currency: currency.conversion }]
          } else {
            this.form.available_documents = [{ document: 'US1', currency: currency.id }]
          }

          this.form.available_countries = this.baseCountries.map(c => c.id)
          this.form.available_plans = [{
            allow_quantity: false,
            description: plan.description,
            name: plan.name,
            plan: plan.id
          }]
        } else {
          return false
        }

        // create a signup form
        const form = await this.createForm()

        if (form) {
          this.epMainInside = 1
        } else {
          return false
        }
      }

      // register event in Segment
      this.trackEvent('Quickstart Step Completed', {
        action_label: 'Continue',
        element: 'Button',
        step: 'Create a plan'
      })

      // update organization onboarding
      if (!this.editableOnboarding.plan) {
        this.editableOnboarding.plan = true
        this.updateOnboarding('editableOnboarding')
      }
    },
    completeStepTwo () {
      this.editableBranding.logo = this.$refs['editableBranding.logo'].files[0]
      this.$v.editableBranding.$touch()

      if (this.$v.editableBranding.$invalid) {
        return false
      }

      const payload = new FormData()

      if (this.editableBranding.logo) {
        payload.append('logo', this.editableBranding.logo, this.editableBranding.logo.name)
      }

      payload.append('color_background', this.editableBranding.color_background)

      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: payload,
        id: this.accountsDetail.id,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        this.$store.commit('auth/SET_ACCOUNT', { account: response.data, redirect: false })
        this.editableBranding = {
          logo: response.data.logo,
          color_background: response.data.color_background
        }

        if (!this.editableOnboarding.branding) {
          this.editableOnboarding.branding = true
          this.updateOnboarding('editableOnboarding')
        }

        this.epMainInside = 2
        this.resetLogoField()
      })
      .then(() => {
        // register event in Segment
        this.trackEvent('Quickstart Step Completed', {
          action_label: 'Continue',
          element: 'Button',
          step: 'Custom your brand'
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    completeStepThreeAndFour () {
      const publishableKey = this.formsDetail.publishable_key
      const windowUrl = `${this.$CLIENT_BASE}/signup-forms/${publishableKey}/preview`
      const windowSettings = 'toolbar=yes,scrollbars=yes,resizable=yes,width=980,height=760,top=40,left=40'

      window.open(windowUrl, '_blank', windowSettings)

      if (!this.editableOnboarding.signup_form || !this.editableOnboarding.signup_form_setup) {
        this.editableOnboarding.signup_form = true
        this.editableOnboarding.signup_form_setup = true
        this.updateOnboarding('editableOnboarding')
      }
      this.epMainInside = 3

      // register event in Segment
      this.trackEvent('Quickstart Step Completed', {
        action_label: 'Preview',
        element: 'Button',
        step: 'Preview your signup experience'
      })
    },
    async createPlan () {
      try {
        const r = await this.$store.dispatch('subscriptions/CREATE', {
          resource: 'plans',
          payload: this.plan
        })
        return r.data
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
        return false
      }
    },
    async createProduct () {
      try {
        const r = await this.$store.dispatch('subscriptions/CREATE', {
          resource: 'products',
          payload: this.product
        })
        return r.data
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
        return false
      }
    },
    async createForm () {
      try {
        const r = await this.$store.dispatch('apps/CREATE', {
          resource: 'signup_forms/forms',
          payload: this.form
        })
        return r.data
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
        return false
      }
    },
    getLogoPreview (e) {
      if (e.target.files.length) {
        this.logoPreview = URL.createObjectURL(e.target.files[0])
      } else {
        this.logoPreview = ''
      }
    },
    resetLogoField () {
      this.$refs['editableBranding.logo'].type = 'text'
      this.$refs['editableBranding.logo'].type = 'file'
      this.logoPreview = ''
    },
    updateOnboarding () {
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'onboardings',
        id: this.onboarding.id,
        payload: this.editableOnboarding
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    plan: {
      amount: {
        required,
        decimal
      },
      currency: {
        required
      },
      name: {
        required,
        maxLength: maxLength(56)
      }
    },
    editableBranding: {
      color_background: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(7)
      }
    }
  }
}
</script>
<style>
::v-deep .v-text-field .v-input__append-inner {
  padding-left: 3px !important;
  margin-top: 3px !important;
  margin-bottom: 2px !important;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
.v-alert-custom .v-icon.v-alert__icon {
  font-size: 24px !important;
  margin-left: 8px !important;
}
</style>